import axios from 'axios';
import { HttpDefaultHeaders } from './Defaults';

const AUTH_TOKEN_COOKIE_NAME = 'SCHEDULER_AUTH_TOKEN';

export const GetUserMe = () => {
    return axios.get(`oauth/user/me`);
}

export const GetAuthTokenCookie = (cookies) => {
    return cookies.get(AUTH_TOKEN_COOKIE_NAME, { path: '/' });
}

export const SetAuthTokenCookie = (cookies, token) => {
    cookies.set(AUTH_TOKEN_COOKIE_NAME, token, { path: '/' });
}

export const DelAuthTokenCookie = (cookies) => {
    cookies && cookies.remove(AUTH_TOKEN_COOKIE_NAME, { path: '/' });
}

export const SetHttpDefaultHeaders = (token) => {
    HttpDefaultHeaders('Authentication-Token', token);
}



// WEBPACK FOOTER //
// ./src/components/http/AuthService.js